import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { notifGuard } from './guard';
import { NotificationsDropdownPreferencesComponent } from './notifications-dropdown-preferences.component';
import { NotificationsDropdownComponent } from './notifications-dropdown.component';
import { NotificationsListComponent } from './notifications-list.component';


const routes: Routes = [
    {
        path: 'list',
        canActivate: [notifGuard],
        runGuardsAndResolvers: 'always',
        component: NotificationsDropdownComponent,
        outlet: 'notifications',
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: NotificationsListComponent,
            },
        ],
    },
    {
        path: 'settings',
        canActivate: [notifGuard],
        runGuardsAndResolvers: 'always',
        component: NotificationsDropdownComponent,
        outlet: 'notifications',
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: NotificationsDropdownPreferencesComponent,
            },
        ],
    },
];


@NgModule({
    imports: [
        RouterModule.forChild(routes),
    ],
})
export class NotificationsModule {}
